import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import WebsitePreview from './WebsitePreview';

const getFormIdentifier = pageType => {
  return (pageType && `${pageType.toLowerCase()}EditPageForm`) || 'EditPageForm';
};

const mapStateToProps = state => {
  const page = state.website.pages.byId[state.website.pages.activePage.id];
  const pageType = page && page.type;
  const cmsPageFormIdentifier = getFormIdentifier(pageType);
  const cmsPageFormSelector = formValueSelector(cmsPageFormIdentifier);
  const homePageFormSelector = formValueSelector('homepageSection');
  const weddingInfoFormSelector = formValueSelector('weddingInfoForm');
  const isHome = page && page.type === 'HOME';
  const { date, wedding = {}, account = {} } = weddingInfoFormSelector(
    state,
    'date',
    'hashtag',
    'wedding',
    'account'
  );
  return {
    isHome,
    values: isHome
      ? homePageFormSelector(state, 'title', 'header_image_url', 'footer_image_url', 'nav_title')
      : cmsPageFormSelector(state, 'title', 'description', 'hidden', 'header_image_url'),
    activePage: page,
    pages: state.website.pages.orderedIds.map(id => state.website.pages.byId[id]),
    wedding: state.wedding.wedding,
    weddingValues: isHome
      ? {
          date,
          hashtag: wedding.hashtag,
          title: wedding.title,
          city: account.city,
          stateProvince: account.state_province,
        }
      : null,
    account: state.wedding.account,
    pageComponentKey: pageType,
  };
};

const WebsitePreviewContainer = connect(mapStateToProps)(WebsitePreview);

export default WebsitePreviewContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/WebsitePreview/index.js